import api from './api';

// Transform snake_case to camelCase
const transformGuest = (guest) => ({
  id: guest.id,
  weddingId: guest.wedding_id,
  organizationId: guest.organization_id,
  name: guest.name,
  email: guest.email,
  phone: guest.phone,
  side: guest.side,
  guestCount: guest.guest_count,
  rsvpStatus: guest.rsvp_status,
  mealPreference: guest.meal_preference,
  hotelId: guest.hotel_id,
  hotelName: guest.hotel_name,
  roomNumber: guest.room_number,
  roomAllocation: guest.room_allocation,
  checkInDate: guest.check_in_date,
  checkOutDate: guest.check_out_date,
  hotelAddress: guest.hotel_address,
  numberOfRooms: guest.number_of_rooms,
  roomNumbers: guest.room_numbers,
  transportRequired: guest.transport_required,
  transportDetails: guest.transport_details,
  notes: guest.notes
});

// Transform camelCase to snake_case
const transformGuestToSnakeCase = (guest) => ({
  name: guest.name,
  email: guest.email,
  phone: guest.phone,
  side: guest.side,
  guest_count: guest.guestCount,
  rsvp_status: guest.rsvpStatus,
  meal_preference: guest.mealPreference,
  hotel_id: guest.hotelId,
  hotel_name: guest.hotelName,
  room_number: guest.roomNumber,
  room_allocation: guest.roomAllocation,
  check_in_date: guest.checkInDate,
  check_out_date: guest.checkOutDate,
  hotel_address: guest.hotelAddress,
  number_of_rooms: guest.numberOfRooms,
  room_numbers: guest.roomNumbers,
  transport_required: guest.transportRequired,
  transport_details: guest.transportDetails,
  notes: guest.notes
});

export const guestService = {
  async getGuests(weddingId, organizationId) {
    const response = await api.get(`/api/guests?wedding_id=${weddingId}&organization_id=${organizationId}`);
    return response.data.map(transformGuest);
  },

  async getGuest(guestId) {
    const response = await api.get(`/api/guests/${guestId}`);
    return transformGuest(response.data);
  },

  async createGuest(organizationId, weddingId, guestData) {
    const payload = transformGuestToSnakeCase(guestData);
    const response = await api.post(`/api/guests?wedding_id=${weddingId}&organization_id=${organizationId}`, payload);
    return transformGuest(response.data);
  },

  async updateGuest(organizationId, weddingId, guestId, guestData) {
    const payload = transformGuestToSnakeCase(guestData);
    const response = await api.put(`/api/guests/${guestId}`, payload);
    return transformGuest(response.data);
  },

  async deleteGuest(organizationId, weddingId, guestId) {
    const response = await api.delete(`/api/guests/${guestId}`);
    return response.data;
  },

  async sendAccommodationDetails(guestId) {
    const response = await api.post(`/api/guests/${guestId}/send-accommodation`);
    return response.data;
  },

  async bulkUpdateRsvp(guestIds, rsvpStatus) {
    const response = await api.post('/api/guests/bulk-update-rsvp', {
      guest_ids: guestIds,
      rsvp_status: rsvpStatus
    });
    return response.data;
  },

  async bulkDelete(organizationId, weddingId, guestIds) {
    const response = await api.post('/api/guests/bulk-delete', {
      guest_ids: guestIds,
      wedding_id: weddingId,
      organization_id: organizationId
    });
    return response.data;
  },

  async bulkSendAccommodation(guestIds, method = 'both') {
    const response = await api.post('/api/guests/bulk-send-accommodation', {
      guest_ids: guestIds,
      method: method
    });
    return response.data;
  }
};
